import { USERS_PATH } from "./DBPathConstants.js";
import { PrefixedFirebaseWrapper } from "./PrefixedFirebaseWrapper";
export class UserIdFirebaseWrapper extends PrefixedFirebaseWrapper {
    constructor(firebase, userId) {
        super(firebase, `${USERS_PATH}/${userId}`);
    }
}
//# sourceMappingURL=UserIdFirebaseWrapper.js.map